import React, { memo } from 'react'
import { OutlinedField } from '../Forms'

const SlugField = memo(({ classes, handleChange, value }) => {
  return (
    <OutlinedField
      label="Slug"
      className={classes.textField}
      value={value}
      onChange={handleChange('slug')}
      required
    />
  )
})

export default SlugField
